import { render } from "./InactiveComponent.vue?vue&type=template&id=667d5cca"
import script from "./InactiveComponent.vue?vue&type=script&lang=js"
export * from "./InactiveComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Apps/sendcloudholidaygiftsraffle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__